import styled from '@emotion/styled';
import { Text, Icon, Link, Button, tokens } from '@hotjar/hotsauce';

export const Container = styled.div`
  display: flex;
  height: 100%;
  width: 100%;

  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const Subtitle = styled(Text)`
  margin-top: ${tokens.spacer.x1pt5};
  max-width: 450px;

  white-space: pre-line;
  color: #666;
`;

export const CheckIcon = styled(Icon)`
  margin-bottom: ${tokens.spacer.x2pt5};
`;

export const TrackingButton = styled(Button)`
  margin-top: ${tokens.spacer.x2};
`;

export const EnabledSubtitle = styled(Subtitle)`
  margin-top: ${tokens.spacer.x2};
`;

export const StyledLink = styled(Link)`
  color: ${tokens.color.text_default};
  text-decoration: underline;
`;
